import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, Scroll } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private lastRoute: string = '';

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  setupScrollRestorationListener(): void {
    if (isPlatformBrowser(this.platformId)) {
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }

      this.router.events.pipe(filter((event: any): event is Scroll => event instanceof Scroll)
          ).subscribe((e:any) => {
            let routerEvent:NavigationEnd = e.routerEvent;
            const isNavigatingToAvailability = routerEvent.urlAfterRedirects.includes('/availability');
            const isNavigatingToProfile = routerEvent.urlAfterRedirects.includes('/profile');
            const isNavigatingToCheckout = routerEvent.urlAfterRedirects.includes('/checkout');
            const isNavigatingToDining = routerEvent.urlAfterRedirects.includes('/restaurant/');

            if (isNavigatingToAvailability) {
              requestAnimationFrame(() => {
                this.scrollToElementPosition('#multiRoomScrollAnchor');
              });
            }

            if (isNavigatingToProfile) {
              requestAnimationFrame(() => {
                this.scrollToElementPosition('#profileScrollAnchor');
              });
            }

            // gift card pages

            if (isNavigatingToCheckout) {
              requestAnimationFrame(() => {
                this.scrollToElementPosition('#checkoutScrollAnchor');
              });
            }

            if (isNavigatingToDining && this.lastRoute.includes('/restaurant/')) {
              requestAnimationFrame(() => {
                this.scrollToElementPosition('#restaurantScrollAnchor');
              });
            }

            this.lastRoute = routerEvent.urlAfterRedirects;
          });
        }
    
  }

  scrollToElementPosition(selector:string, topRoom?:number) {
      if (!topRoom) {
        topRoom = 15;
      }
      let element:HTMLBaseElement|null = document.querySelector(selector);
      if (element) {

        let elementPosition = element.getBoundingClientRect().top;
        let offsetPosition = elementPosition - this.getFixedHeaderHeight() - topRoom;

        window.scrollBy({
          top: offsetPosition,
          behavior: "smooth"
        });
      }  
  }

  /*
    Gets the header height if a header is fixed. Otherwise returns 0
  */ 

  getFixedHeaderHeight() {
    let height = 0;
    let headerChildren:HTMLCollection|undefined = document.getElementById('hlx-header-content')?.children;

    if (headerChildren) {

      for (let i = 0; i < headerChildren.length; i++) {
        // if one child is fixed, assume that the header is fixed.
        if (window.getComputedStyle(headerChildren[i]).getPropertyValue('position') == 'fixed') {
          height = headerChildren[i].getBoundingClientRect().height;
        }
      }
    
    }
    
    return height;
  }
}